import { extendTheme } from '@rbilabs/universal-components/themes';
import { fhsTheme } from '@rbilabs/universal-components/themes/fhs';

import { designTokens } from '../constants/design-tokens';

export const theme = extendTheme(fhsTheme, {
  nativeBaseTheme: {
    colors: {
      // @ts-ignore
      __legacyToken: designTokens,
    },
  },
});
